import { render } from "./vercuentaspendientes.vue?vue&type=template&id=e2d2619e&scoped=true"
import script from "./vercuentaspendientes.vue?vue&type=script&lang=js"
export * from "./vercuentaspendientes.vue?vue&type=script&lang=js"

import "./vercuentaspendientes.vue?vue&type=style&index=0&id=e2d2619e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2d2619e"]])

export default __exports__